<div class="overlay privacy-policy-modal">
    <div class="overlay-header">
        <h2>{{title}}</h2>
    </div>
    <div class="section-divider"></div>
    <form>
        <div class="overlay-body">
            <div class="container">
            <div class="section-heading">Read to the customer:</div>
            <p id="step-1"  *ngIf="step1Visible">
                {{note}}
                <button type="button" class="privacy-link" (click)="navigateToPrivacyPolicyUrl()">Privacy Policy | Alight</button>.
                Do you acknowledge this?
            </p>

            <p id="step-2"  *ngIf="step2Visible">
               {{privacyPolicyConsent}}
            </p>
            </div>
        </div>
    </form>
  
<div class="button-controls hide1 container" *ngIf="step1Visible">
  <f-button text="No" title="No" type="button" variant="action" (click)="step1Visible=false; step2Visible=true;">
  </f-button>
  <f-button text="Yes" title="Yes" variant="progressive" type="button" [disabled]="isButtonDisabled" (click)="updatePrivacyPolicy()">
  </f-button>
</div>

<div class="button-controls container" *ngIf="step2Visible">
  <f-button text="Back" title="Back" type="button" variant="action" (click)="step1Visible=true; step2Visible=false;">
  </f-button>
  <f-button text="Got it" title="Got it" variant="progressive" type="button" (click)="closePolicyPopup()">
  </f-button>
</div>
<!-- code commented due no feature implemented privacy-link, we will uncomment and use once we have next US realated to privacy policy-link. -->

<div class="container" *ngIf="step1Visible">
    <p class="preserve-breaks">
    {{note2}} <button type="button" class="privacy-link" (click)="navigateToPrivacyPolicy()">click here</button> to send
    the Privacy policy link for them to review.
    </p>
</div>

</div>
